import image from '../assets/bug-solid-cultured-50.png';

import styles from '../styles/base_components/PageNotFound.module.scss';

function Unauthorized(props) {
  return (
    <div className={styles.pageNotFound}>
      <h1>4</h1>
      <img src={image} alt='Bug Solid Cultured 50'/>
      <h1>1</h1>
      <h2>unauthorized</h2>
    </div>
  );
}

export default Unauthorized;